import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {FormattedMessage, injectIntl} from 'react-intl';
import moment from 'moment';
import {projectStatusColors} from '../../constants';
import Util from '../../forecast-app/shared/util/util';
import RichTextItem from '../../components/richtext_item';
import CreateProjectStatusMutation from '../../mutations/create_project_status_mutation';
import {createToast} from '../../forecast-app/shared/components/toasts/another-toast/toaster';
import Person from '../../forecast-app/shared/components/person/person';
import CustomScrollDiv from '../../forecast-app/shared/components/scroll-bars/custom_scroll_div';
import GenericModal from './generic_modal';
import {BUTTON_COLOR, BUTTON_STYLE} from '../../constants';
import Button from '../../forecast-app/shared/components/buttons/button/button';
import {cloneDeep} from 'lodash';
import {profilePicSrc} from '../../directApi';

class projectStatusModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			statusColor: this.props.viewer.project.currentProjectStatus
				? this.props.viewer.project.currentProjectStatus.color
				: '',
			description: null,
			selectedLabels: [],
		};
	}

	handleStatusColorChange(color) {
		if (this.rich && this.rich.handleBlur) {
			this.rich.handleBlur();
		}
		this.setState({statusColor: color});
	}

	handleStatusDescriptionChange(description) {
		this.setState({description: description});
	}

	handleSave() {
		const onSuccess = () => {
			createToast({message: this.props.intl.formatMessage({id: 'project_status_modal.status_saved'}), duration: 3000});
			this.props.closeModal();
		};
		Util.CommitMutation(
			CreateProjectStatusMutation,
			{
				projectId: this.props.viewer.project.id,
				color: this.state.statusColor,
				description: this.state.description,
			},
			onSuccess
		);
		this.setState({description: null});
	}

	render() {
		const {formatMessage} = this.props.intl;
		const dateFormat = this.props.viewer.language === 'ENGLISH_US' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
		const project = this.props.viewer.project;
		const projectLocked = project.status === 'HALTED' || project.status === 'DONE';
		const mentions =
			project.projectPersons &&
			project.projectPersons.edges
				.filter(projectPerson => {
					return projectPerson.node.person.active;
				})
				.map(projectPerson => {
					return {
						personId: projectPerson.node.person.id,
						name: projectPerson.node.person.firstName + ' ' + projectPerson.node.person.lastName,
						avatar: profilePicSrc(projectPerson.node.person.profilePictureId),
					};
				});

		let mentionsLabels = [];
		for (const label of this.props.viewer.company.labels.edges) {
			if (!this.state.selectedLabels.includes(label.node.id)) {
				mentionsLabels.push({id: label.node.id, name: label.node.name});
			}
		}

		const content = (
			<>
				{!projectLocked ? (
					<div className="status-controls">
						<svg
							className="project-status-color"
							height="36px"
							width="36px"
							onClick={this.handleStatusColorChange.bind(this, Util.getProjectStatusColorHex('GREEN'))}
						>
							<circle
								cx="16"
								cy="16"
								r="15"
								stroke={Util.getProjectStatusColorName(this.state.statusColor) === 'GREEN' ? '#757575' : null}
								strokeWidth="1.5"
								style={{fill: projectStatusColors[0]}}
							/>
						</svg>
						<svg
							className="project-status-color"
							height="36px"
							width="36px"
							onClick={this.handleStatusColorChange.bind(this, Util.getProjectStatusColorHex('YELLOW'))}
						>
							<circle
								cx="16"
								cy="16"
								r="15"
								stroke={Util.getProjectStatusColorName(this.state.statusColor) === 'YELLOW' ? '#757575' : null}
								strokeWidth="1.5"
								style={{fill: projectStatusColors[1]}}
							/>
						</svg>
						<svg
							className="project-status-color"
							height="36px"
							width="36px"
							onClick={this.handleStatusColorChange.bind(this, Util.getProjectStatusColorHex('RED'))}
						>
							<circle
								cx="16"
								cy="16"
								r="15"
								stroke={Util.getProjectStatusColorName(this.state.statusColor) === 'RED' ? '#757575' : null}
								strokeWidth="1.5"
								style={{fill: projectStatusColors[2]}}
							/>
						</svg>
						<RichTextItem
							cy={'status-description-text-area'}
							ref={rich => (this.rich = rich)}
							projectLocked={false}
							alwaysShowControls={true}
							characterLimit={this.props.viewer.company.characterLimit}
							text={this.state.description}
							placeholder={formatMessage({id: 'settings.project-status-description-placeholder'})}
							handleTextChange={this.handleStatusDescriptionChange.bind(this)}
							mentions={mentions}
							mentionsLabels={mentionsLabels}
							fixedSize={true}
						/>
						<Button
							cy="save-status-button"
							className="save-button"
							text={formatMessage({id: 'common.save'})}
							buttonStyle={BUTTON_STYLE.FILLED}
							colorTheme={BUTTON_COLOR.GREEN}
							onClick={this.handleSave.bind(this)}
						/>
					</div>
				) : (
					''
				)}
				<div className="table-wrapper">
					<CustomScrollDiv>
						<table className="status-table">
							<thead>
								<tr>
									<th className="th-status">
										<FormattedMessage id="common.status" />
									</th>
									<th className="th-description">
										<FormattedMessage id="common.description" />
									</th>
									<th className="th-date">
										<FormattedMessage id="common.date" />
									</th>
									<th className="th-person">
										<FormattedMessage id="project_status_modal.changed_by" />
									</th>
								</tr>
							</thead>
							<tbody>
								{cloneDeep(project.projectStatuses.edges)
									.sort((a, b) => {
										const aCreatedDate = moment.utc({
											y: a.node.year,
											M: a.node.month - 1,
											d: a.node.day,
											h: a.node.hour,
											m: a.node.minute,
											s: a.node.second,
										});
										const bCreatedDate = moment.utc({
											y: b.node.year,
											M: b.node.month - 1,
											d: b.node.day,
											h: b.node.hour,
											m: b.node.minute,
											s: b.node.second,
										});
										return aCreatedDate.isBefore(bCreatedDate) ? 1 : -1;
									})
									.map((projectStatus, index) => (
										<tr key={index}>
											<td className="status-color-cell">
												<svg
													className={'project-status-color'}
													height="36px"
													width="36px"
													onClick={this.handleStatusColorChange.bind(this, 'test')}
												>
													<circle cx="14" cy="14" r="13" style={{fill: projectStatus.node.color}} />
												</svg>
											</td>
											<td className="status-description">
												<RichTextItem
													cy={'status-description'}
													projectLocked={false}
													alwaysShowControls={false}
													readOnly={true}
													text={projectStatus.node.description}
													placeholder={''}
												/>
											</td>
											<td>
												{Util.CreateNonUtcMomentDate(
													projectStatus.node.year,
													projectStatus.node.month,
													projectStatus.node.day
												).format(dateFormat)}
											</td>
											<td>
												<Person
													name={
														(projectStatus.node.person.firstName
															? projectStatus.node.person.firstName
															: '') +
														' ' +
														(projectStatus.node.person.lastName
															? projectStatus.node.person.lastName
															: '')
													}
													role={''}
													showName={true}
													showRole={false}
													imageSrc={profilePicSrc(projectStatus.node.person.profilePictureId)}
													imageSize="medium"
												/>
											</td>
										</tr>
									))}
							</tbody>
						</table>
					</CustomScrollDiv>
				</div>
			</>
		);
		return (
			<GenericModal
				wrapperClassName="project-status-modal"
				closeModal={this.props.closeModal}
				headerText={formatMessage({id: 'settings.project-status'})}
				content={content}
			/>
		);
	}
}

const projectStatusModalQuery = graphql`
	query projectStatusModal_Query($projectId: String) {
		viewer {
			actualPersonId
			component(name: "project_status_modal")
			project(id: $projectId) {
				id
			}
			...projectStatusModal_viewer @arguments(projectId: $projectId)
		}
	}
`;

export {projectStatusModalQuery};

export default injectIntl(
	createFragmentContainer(projectStatusModal, {
		viewer: graphql`
			fragment projectStatusModal_viewer on Viewer @argumentDefinitions(projectId: {type: "String"}) {
				id
				actualPersonId
				firstName
				lastName
				language
				project(id: $projectId) {
					id
					name
					status
					statusDescription
					currentProjectStatus {
						id
						color
						description
					}
					projectPersons(first: 10000) {
						edges {
							node {
								id
								person {
									id
									active
									firstName
									lastName
									profilePictureId
									profilePictureDefaultId
								}
							}
						}
					}
					projectStatuses(first: 10000) @connection(key: "Project_projectStatuses") {
						edges {
							node {
								id
								person {
									id
									firstName
									lastName
									profilePictureId
									profilePictureDefaultId
								}
								description
								color
								day
								month
								year
								hour
								minute
								second
							}
						}
					}
				}
				company {
					characterLimit
					labels(first: 10000) {
						edges {
							node {
								id
								name
							}
						}
					}
				}
			}
		`,
	})
);
